export const membersData = [
    {
      name: "Aarhan Khan",
      quote: "developer of this site",
      insta: "https://www.instagram.com/aarhan_._/",
      github: "https://github.com/aarhank",
      linkedin: "https://www.linkedin.com/in/aarhan-k-62742b196/",
    },
	
	  {
      name: "Ansh Agrawal",
      quote: "member",
      insta: "",
      github: "",
      linkedin: "",
    },
  {
      name: "Pranav Rajput",
      quote: "member",
      insta: "",
      github: "",
      linkedin: "",
    },
    {
      name: "Shubh Saxena",
      quote: "Member",
      insta: "https://www.instagram.com/_shubh.28/",
      github: "https://github.com/shubh-28",
      linkedin: "",
    },
    {

      name: "Deep Shekhar",
      quote: "Member",
      insta: "https://www.instagram.com/finding_myself_429/",
      github: "https://github.com/deep429",
      linkedin: "https://www.linkedin.com/in/deep-shekhar-2087711b9/",
    },
    {
      name: "Aayush Girdhar",
      quote: "member of ACM JUIT",
      insta: "https://www.instagram.com/g.aayush_/",
      github: "https://github.com/AayushG02",
      linkedin: "https://www.linkedin.com/in/aayushgirdhar/",
    },
	{
      name: "Ayush Pratap Singh",
      quote: "member of ACM juit 2021 batch",
      insta: "",
      github: "",
      linkedin: "",
    },
 
    {
      name: "Abhinandan Thakur",
      quote: "member",
      insta: "",
      github: "",
      linkedin: "",
    },  
     {
      name: "Divyansh Sehgal",
      quote: "Member",
      insta: "https://www.instagram.com/divyansh_sehgal/",
      github: "https://github.com/Divi03",
      linkedin: "https://www.linkedin.com/in/divyansh-sehgal-095293222/",
    },
    {
      name: "Saumya Bansal",
      quote: "Member of ACM JUIT",
      insta: "",
      github: "https://github.com/saumyabansal17",
      linkedin: "",
    }, 
    {
      name: "Ujjwal Pathak",
      quote: "Member at ACM JUIT",
      insta: "https://www.instagram.com/ujjwalpathaak/",
      github: "https://github.com/UjjwalPathaak",
      linkedin: "https://www.linkedin.com/in/ujjwal-pathak-55272721b/",
    },
  {
      name: "Paras Dhiman",
      quote: "member of ACM JUIT",
      insta: "https://www.instagram.com/i_._anonymous.re/",
      github: "https://github.com/dhimanparas20",
      linkedin: "https://www.linkedin.com/in/parasdhiman-211382/",
    },
    {
      name: "Aaditya jain",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/asmodeus__16/",
      github: "https://github.com/Aaditya016",
      linkedin: "https://www.linkedin.com/in/Ajxfifa19/",

    },
     {
      name: "Alisha Siddiqui",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/aswritessss/",
      github: "https://github.com/aswritesssss",
      linkedin: "https://alishasiddiqui.substack.com/",

    },
 {
      name: "Shivansh",
      quote: "Member",
      insta: "https://www.instagram.com/_shivansh02_/",
      github: "https://github.com/Shivansh0293",
      linkedin: "",
    },
     {
      name: "Aparna Srivastava",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/aparna._.25/",
      github: "https://github.com/aparna2573",
      linkedin: "https://www.linkedin.com/in/aparna-srivastava-44558221b/",

    },
{
      name: "Nilakshi sharma",
      quote: "Member of ACM JUIT",
      insta: "",
      github: "",
      linkedin: "",
},
    {
      name: "SHIVANSH",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/shivanshmehrotra_14",
      github: "https://github.com/S-Mcode2hack",
      linkedin: "https://www.linkedin.com/in/Shivansh-Mehrotra14",
    },
  {
      name: " Harshit Srivastava",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/sub_savage/",
      github: "https://github.com/subsavage",
    },
	{
      name: "Vaibhav Sharma",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/vaaibhavsharma/",
      github: "https://github.com/vaaibhavsharma",
      linkedin: "https://www.linkedin.com/in/vaaibhavsharma/",
  },
    {
      name: "Kinzang Wangdi",
      quote: "Member of ACM JUIT",
      insta: "https://www.instagram.com/geek.beats/",
      github: "https://github.com/geekbeats",
      linkedin: "",
    },
  {
      name: "Aayush Gupta",
      quote: "Member of ACM JUIT",
      insta: "",
      github: "",
      linkedin: "",
    },
    {
      name: "Aditya Bansal",
      quote: "member of ACM-JUIT",
      insta: "",
      github: "https://github.com/Aditya3403",
      linkedin: "https://www.linkedin.com/in/aditya-bansal-036b36211/",
    },{
      name: "Aadya Thakur",
      quote: "member of ACM",
      insta: "https://www.instagram.com/aadyathakur/",
      github: "https://github.com/aadya-21",
      linkedin: "",
    },{
      name: "Aayush Sharma",
      quote: "Member of ACM-JUIT",
      insta: "https://www.instagram.com/ayushsharma8952/",
      github: "https://github.com/Aayush61000",
      linkedin: "https://www.linkedin.com/in/ayush-sharma-567b59209/",
    },
{
      name: "Nitish Kumar Gupta",
      quote: "Member of ACM-JUIT",
      insta: "https://www.instagram.com/yr.nitish/",
      github: "https://github.com/yr-nitish",
      linkedin: "https://www.linkedin.com/in/nitish-gupta-6b017721a/",
    },
    {
      name: "Kartikey Attri",
      quote: "member of ACM",
      insta: "https://www.instagram.com/attrikartikey/",
      github: "https://github.com/attrikartikey",
      linkedin: "",
    },
  {
      name: "Arun Thakur",
      quote: "member of ACM-JUIT",
      insta: "https://www.instagram.com/_arunthakur_07/",
      github: "https://github.com/Arunthakur07",
      linkedin: "",
    },
    {
      name: "Raghav Bansal",
      quote: "Member of site",
      insta: "https://www.instagram.com/raghavbans_l/?hl=en",
      github: "https://github.com/raghavbansal18",
      linkedin: "https://www.linkedin.com/in/raghav-bansal-534888219/",
    },
  {
      name: "Aarhan Khan",
      quote: "developer of this site",
      insta: "https://www.instagram.com/aarhan_._/",
      github: "https://github.com/bdab-x",
      linkedin: "https://www.linkedin.com/in/aarhan-k-62742b196/",
    },
  {
      name: "Akhil Dhawan",
      quote: "Member of ACM",
      insta: "",
      github: "",
      linkedin: "",
    },

{
      name: "Malay Acharya",	
      quote: "hehe",
      insta: "sus",
      github: "sus",
      linkedin: "sus",
    },
	 {
      name: "Syed Mohammad Zaeem  ",
      quote: "a member of ACM JUIT",
      insta: "NA",
      github: "NA",
      linkedin: "NA",
    },
	{
      name: "Rakshita jain",	
      quote: "nice",
      insta: "",
      github: "",
      linkedin: "",
    },
	{
      name: "Rishabh",
      quote: "dil chahta hai",
      insta: "bas",
      github: "bas",
      linkedin: "bas",
    },
	 {
      name: "Vidushi",
      quote: "Member of ACM-JUIT",
      insta: "https://www.instagram.com/vidushidwivedi_3/",
      github: "https://github.com/vidushidwivedi",
      linkedin: "http://linkedin.com/in/vidushi-dwivedi-427a85222",
    },
    {
      name: "Ansh Mehrotra",
      quote: "Member of ACM",
      insta: "https://www.instagram.com/ansh_._mehrotra/",
      github: "https://github.com/mehrotra-ansh",
      linkedin: "",
    },
{
      name: "Swapnil Tyagi",
      quote: "Member of ACM-JUIT",
      insta: "https://www.instagram.com/swapnil_tyagi01/",
      github: "https://github.com/SwapnilTyagi01",
      linkedin: "https://www.linkedin.com/in/swapnil-tyagi-114383215/",
    },
    {
      name: "Moulik Chaturvedi",
      quote: "Member of ACM-JUIT",
      insta: "https://www.instagram.com/multidimensionalspacesnake/",
      github: "https://github.com/moulikchaturvedi",
      linkedin: "https://www.linkedin.com/in/moulikchaturvedi/",
    },
    {
      name: "Dev Pratap Tyagi",
      quote: "Ex-Chairperson of ACM-JUIT",
      insta: "https://www.instagram.com/_devtyagi_/",
      github: "https://github.com/devptyagi",
      linkedin: "https://www.linkedin.com/in/devtyagi/",
    }
  ];
